import { NumberInput } from "../../shared/NumberInput";
import { fmtEUR } from "../../lib/calculations";
import { REGIONS, type SimulationInput } from "../../lib/types";

interface Props {
  input: SimulationInput;
  update: <K extends keyof SimulationInput>(k: K, v: SimulationInput[K]) => void;
  total: number;
}

export function StepBien({ input, update, total }: Props) {
  return (
    <div className="space-y-5">
      <header>
        <p className="text-sm font-medium text-primary">Étape 1 / 4</p>
        <h2 className="mt-1 text-2xl font-bold text-foreground">Parlez-nous du bien</h2>
      </header>

      <NumberInput
        label="Prix d'acquisition"
        value={input.prixAcquisition}
        onValueChange={(n) => {
          update("prixAcquisition", n);
          if (input.mobilier === Math.round(input.prixAcquisition * 0.05)) {
            update("mobilier", Math.round(n * 0.05));
          }
        }}
        helper="Prix d'achat, frais de notaire inclus"
        placeholder="ex: 250 000"
        required
      />

      <NumberInput
        label="Travaux réalisés ou prévus"
        value={input.travaux}
        onValueChange={(n) => update("travaux", n)}
        helper="Rénovation, aménagement. 0 si neuf."
        placeholder="ex: 15 000 (ou 0 si neuf)"
      />

      <NumberInput
        label="Mobilier"
        value={input.mobilier}
        onValueChange={(n) => update("mobilier", n)}
        helper="Meubles, électroménager. Estimé auto à 5%, modifiable."
        placeholder="ex: 12 500 (auto = 5% du bien)"
      />

      <div className="space-y-1.5">
        <label htmlFor="region-select" className="block text-sm font-medium text-foreground">Région</label>
        <select
          id="region-select"
          aria-label="Région"
          value={input.region}
          onChange={(e) => update("region", e.target.value)}
          className="block w-full rounded-lg border border-input bg-background px-3 py-2.5 text-base text-foreground shadow-sm outline-none focus:border-primary focus:ring-2 focus:ring-primary/30"
        >
          {REGIONS.map((r) => (
            <option key={r} value={r}>{r}</option>
          ))}
        </select>
      </div>

      <div className="rounded-xl border border-success/30 bg-success/10 p-4" role="status">
        <p className="text-sm text-foreground">
          Investissement total :{" "}
          <strong className="tabular font-bold text-base text-foreground">
            {fmtEUR(total)}
          </strong>
        </p>
      </div>
    </div>
  );
}
